module.exports = __webpack_public_path__ + "img/book5.35b17f82.png";